import _ from 'lodash';
import { BsTwitterX } from 'react-icons/bs';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LineIcon, LineShareButton, TwitterShareButton } from 'react-share';
import { APP_URL } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

const WidgetShareArticle = ({ articleLink = null, round = false, eventDataLayer, ...props }) => {
  if (_.isEmpty(articleLink)) return null;
  const shareLink = `${APP_URL}${articleLink}`;
  return (
    <>
      <WidgetWrapper id='widget-share' {...props}>
        {/* <div className='head-share flex-start'>
            Share on
        </div> */}
        <ul>
          <li>
            <FacebookShareButton
              url={shareLink}
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: 'facebook',
                    heading: 'facebook',
                    index: 1
                  }
                })
              }
            >
              <FacebookIcon size={30} round={`${round}`} />
            </FacebookShareButton>
          </li>
          <li>
            <TwitterShareButton
              url={shareLink}
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: 'twitter',
                    heading: 'twitter',
                    index: 2
                  }
                })
              }
            >
              <BsTwitterX size={30} round={`${round}`} />
            </TwitterShareButton>
          </li>
          <li>
            <LineShareButton
              url={shareLink}
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: 'line',
                    heading: 'line',
                    index: 3
                  }
                })
              }
            >
              <LineIcon size={30} round={`${round}`} />
            </LineShareButton>
          </li>
          <li>
            <EmailShareButton
              url={shareLink}
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: 'email',
                    heading: 'email',
                    index: 4
                  }
                })
              }
            >
              <EmailIcon size={30} round={`${round}`} />
            </EmailShareButton>
          </li>
        </ul>
      </WidgetWrapper>
    </>
  );
};
const WidgetWrapper = styled.div`
  position: relative;
  display: block;
  margin: 5px 0;
  .head-share {
    font-size: 14px;
    font-weight: 300;
    padding-right: 15px;
    color: #54565a;
  }
  ul {
    display: flex;
    li {
      list-style-type: none;
    }
    button {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 0 3px;
      background: var(--primary-color) !important;
      border: 1px solid var(--primary-color) !important;
      border-radius: 50%;
      svg circle {
        fill: transparent;
      }
      path {
        fill: rgba(0, 0, 0);
      }
      &:hover {
        svg circle {
          fill: rgba(0, 0, 0);
        }
        path {
          fill: var(--primary-color);
        }
      }
    }
  }
`;
export default WidgetShareArticle;
